<template>
    <transition name="fade">
        <div class="page" @scroll="(e) => {handleVerticalScroll(e.target)}" >
            <div class="secondary-header">
                <div @click="() => { this.$router.push({path: '/channels'})}">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"> <path d="M15 6L9 12L15 18" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                    Channels
                </div>
                <div class="dice" v-ripple @click="randomPick">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                        <path d="M22 6.99999C19 6.99999 13.5 6.99999 11.5 12.5C9.5 18 5 18 2 18" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M20 5C20 5 21.219 6.21895 22 7C21.219 7.78105 20 9 20 9" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M22 18C19 18 13.5 18 11.5 12.5C9.5 6.99999 5 7.00001 2 7" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M20 20C20 20 21.219 18.781 22 18C21.219 17.219 20 16 20 16" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>

            <div class="space"></div>

            <div class="content-grid">
                <Channel v-ripple v-for="(k,j) in stations.slice(0,stationCap)" :key="j" :channel="k" />
            </div>

       </div>

    </transition>
  </template>

  <script>
    const Channel = () => import('@/components/Channel')

  export default {
    name: 'StationsList',

    components: {
      Channel,
    },

    watch: {
        // $route() {
        //   this.load()
        //   this.$nextTick(() => {
        //       window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        //   })
        // }
    },

    data: function(){
      return {
        stations: [],
        stationCap: 20,
        loading: true,
      }
    },

    methods: {
            randomPick(){
                const n = Math.floor(Math.random() * this.stations.length)
                this.$router.push({ path: `/channel/${this.stations[n].id}` })
            },

            handleVerticalScroll(container) {
                const isAtEnd = (container.scrollTop + container.clientHeight ) >= (container.scrollHeight - 500);
                if (isAtEnd) {
                    this.stationCap = this.stationCap + 20
                }
            },


            async loadStations(){
                this.loading = true;
                const req = await window.afetch(`/all-stations`)
                const data = await req.json()

                this.stations = window.shuffle(data.stations)

                this.loading = false;
          },

    },

    computed: { },

    activated: function(){
      document.title = `Livestreams - QB`
    },

    mounted: function(){
      this.loadStations()
      document.title = `Livestreams - QB`
    }
  }

  </script>

<style scoped lang="scss">
.page{
    height: 100vh;
    overflow-y: scroll;
    overflow-x: hidden;

}
.secondary-header{
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    padding: 20px 0;
    z-index: 9999;
    background-color: rgba(#141414, 0.75);
    backdrop-filter: blur(10px);
    padding-left: 20px;
    .dice{
        margin-right: 40px;
        padding: 10px;
        background-color: rgba(255,255,255,0.1);
        border-radius: 5px;
        width: 20px;
        height: 20px;
        svg{
            padding: 0;
        }
    }
}
.space{
    height: 70px
}

</style>
<style lang="scss">
.content-grid{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 20px;
    width: calc(100% - 40px);
    justify-content: space-between;
    > a{
        overflow: hidden;
        margin: 5px 0;
        width: calc(50% - 5px);
        padding: 0;
        border-radius: 5px;
        >div{
            width: 100%!important;
            max-width: 100%!important;
        }
    }

}

</style>
